import type { ReadonlyDeep } from 'type-fest';

import {
  PersonInput,
  PersonMembershipInput,
  ThirdPartyTypeEnum,
} from '@e-socna/data-layer';
import { EMPTY_OBJECT } from '@e-socna/empty';

import { pruneInput } from '../../../utils/prune-input.util';

import { addressForm2ApiMapper } from '../../Address/mappers/address.form2api.mapper';
import { isFormEmpty } from '../../utils/is-form-empty.util';
import { codingConfigForm2ApiMapper } from '../../CodingConfig/mappers/coding-config.form2api.mapper';

import type { PersonInput as IPersonInput } from '../hooks/useCreatePersonMutation.hook';
import type { ThirdPartyForm_Person } from '../fragments/person.fragment';

import { bankInfoForm2ApiMapper } from './bank-info.form2api.mapper';
import { contactInfoForm2ApiMapper } from './contact-info.form2api.mapper';

export function personForm2ApiMapper(
  person: ReadonlyDeep<ThirdPartyForm_Person>,
): ReadonlyDeep<IPersonInput> {
  const {
    bankInfo,
    billReceiverId,
    birthDate,
    color,
    contactInfo,
    activeMemberships,
    pictureImageUri,
    signatureImageUri,
    ...personInput
  } = pruneInput(person, PersonInput);

  const result = {
    ...personInput,
    addresses: person.addresses.map(addressForm2ApiMapper),
    bankInfo:
      !bankInfo || isFormEmpty({ node: bankInfo })
        ? null
        : bankInfoForm2ApiMapper(bankInfo),
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    billReceiverId: billReceiverId || null,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    birthDate: birthDate || null,
    ...(color ? { color } : EMPTY_OBJECT),
    codingConfig: codingConfigForm2ApiMapper(person.codingConfig),
    contactInfo:
      !contactInfo || isFormEmpty({ node: contactInfo })
        ? null
        : contactInfoForm2ApiMapper(contactInfo),
    kind: ThirdPartyTypeEnum.Person,
    activeMemberships: activeMemberships.map((membership) =>
      pruneInput(membership, PersonMembershipInput),
    ),
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    firstName: person.firstName || null,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    pictureImageUri: pictureImageUri || null,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    signatureImageUri: signatureImageUri || null,
  };

  return result;
}
